import { useContext, useEffect, useMemo, useState } from 'react'
import { WalletAddressContext } from '@/lib/walletContext'
import {
  getAllTokenBalances,
  getColonyActivity,
  subscribeColonyActivity,
} from '@/lib/colonyActivity'

export function useColonyActivity() {
  const address = useContext(WalletAddressContext)
  const [tick, setTick] = useState(0)

  useEffect(() => subscribeColonyActivity(() => setTick(value => value + 1)), [])

  const activity = useMemo(() => getColonyActivity(address), [address, tick])
  const balances = useMemo(() => getAllTokenBalances(address), [address, tick])

  return { activity, balances, address, tick }
}
